/* eslint-disable import/no-import-module-exports */
/* Import Local Modules */
import Util from "./Util.js";
/**
 * Creates a i18nResolver with a configured type.
 */
function create() {
  return {
    type: Util.getI18nResolverTypeForType('boolean')
  };
}

/* Export Module */
export default {
  TYPE: Util.getI18nResolverTypeForType('boolean'),
  create
};